/** Información del titular de la póliza. */

import PolicyHolderSaveDocument from '@/modules/common/common/models/MID/PolicyHolderSaveDocument'

export default class ForeignHealthPolicyHolderSaveDocument extends PolicyHolderSaveDocument {
  hasPolicyInOtherCompany?: boolean
  student?: string

  constructor(data: any) {
    super(data)
    this.hasPolicyInOtherCompany = data.hasPolicyInOtherCompany
    this.student = data.student
  }
}
